import { OrganizationGroupDTO } from '@reposit/api-client';
import {
  CreateOrganizationGroupPayload,
  UpdatedOrganizationGroupAssignment,
  UpdateOrganizationGroupPayload,
} from './organization-group.types';

export const UPDATE_ORG_GROUP_STORE_KEY = 'ORGANIZATIONS/UPDATE_GROUP';
export const UPDATE_ORG_GROUP_API_REQUESTED = 'ORGANIZATIONS/UPDATE_GROUP_API_REQUESTED';
export const UPDATE_ORG_GROUP_API_SUCCESS = 'ORGANIZATIONS/UPDATE_GROUP_API_SUCCESS';
export const UPDATE_ORG_GROUP_API_FAILED = 'ORGANIZATIONS/UPDATE_GROUP_API_FAILED';

export const CREATE_ORG_GROUP_STORE_KEY = 'ORGANIZATIONS/CREATE_GROUP';
export const CREATE_ORG_GROUP_API_REQUESTED = 'ORGANIZATIONS/CREATE_GROUP_API_REQUESTED';
export const CREATE_ORG_GROUP_API_SUCCESS = 'ORGANIZATIONS/CREATE_GROUP_API_SUCCESS';
export const CREATE_ORG_GROUP_API_FAILED = 'ORGANIZATIONS/CREATE_GROUP_API_FAILED';

export function updateOrganizationGroupRequested(payload: UpdateOrganizationGroupPayload) {
  return {
    type: UPDATE_ORG_GROUP_API_REQUESTED,
    payload,
  } as const;
}

export function updateOrganizationGroupSuccess(payload: UpdatedOrganizationGroupAssignment) {
  return {
    type: UPDATE_ORG_GROUP_API_SUCCESS,
    payload,
  } as const;
}

export function updateOrganizationGroupFailed(error: string) {
  return {
    type: UPDATE_ORG_GROUP_API_FAILED,
    payload: error,
  } as const;
}

export function createOrganizationGroupRequested(payload: CreateOrganizationGroupPayload) {
  return {
    type: CREATE_ORG_GROUP_API_REQUESTED,
    payload,
  } as const;
}

export function createOrganizationGroupSuccess(payload: OrganizationGroupDTO, requestId?: string) {
  return {
    type: CREATE_ORG_GROUP_API_SUCCESS,
    payload,
    meta: {
      requestId,
    },
  } as const;
}

export function createOrganizationGroupFailed(error: string) {
  return {
    type: CREATE_ORG_GROUP_API_FAILED,
    payload: error,
  } as const;
}

export type OrganizationGroupActionTypes = ReturnType<
  | typeof updateOrganizationGroupRequested
  | typeof updateOrganizationGroupSuccess
  | typeof updateOrganizationGroupFailed
  | typeof createOrganizationGroupRequested
  | typeof createOrganizationGroupSuccess
  | typeof createOrganizationGroupFailed
>;
